import { useEffect, useState } from 'react';
import { settingsService } from '../services/api/settings';

export interface Agent {
  id: number;
  title: string;
  summary?: string;
  description?: string;
  category_name?: string;
  category_code?: string;
  output_format?: string;
  mode?: 'lien' | 'natif';
  order?: number;
  /** Produit un support destiné au public : visuel, spot audio, capsule. */
  communication?: boolean;
}

// Le catalogue change rarement au cours d'une session : on le garde en mémoire
// pour que le « @ » réponde immédiatement d'un écran à l'autre.
let enCache: Agent[] | null = null;
let enCours: Promise<Agent[]> | null = null;

const charger = () => {
  if (!enCours) {
    enCours = settingsService
      .getUseCases({ is_active: true })
      .then((liste: any[]) => {
        enCache = (liste || [])
          .filter((a) => a.mode === 'natif')
          .sort((a, b) => (a.order ?? 0) - (b.order ?? 0) || a.title.localeCompare(b.title));
        return enCache;
      })
      .catch((erreur) => {
        enCours = null;
        throw erreur;
      });
  }
  return enCours;
};

/** Les agents de la plateforme, c'est-à-dire les assistants intégrés actifs. */
export function useAgents() {
  const [agents, setAgents] = useState<Agent[]>(enCache || []);
  const [chargement, setChargement] = useState(!enCache);

  useEffect(() => {
    if (enCache) return;
    let annule = false;
    charger()
      .then((liste) => !annule && setAgents(liste))
      .catch(() => {})
      .finally(() => !annule && setChargement(false));
    return () => {
      annule = true;
    };
  }, []);

  return { agents, chargement };
}

/** Libellé court de ce que l'agent rend, affiché à côté de son nom. */
export const SORTIE_AGENT: Record<string, string> = {
  tableau: 'Tableur',
  document: 'Document',
  presentation: 'Présentation',
  audio: 'Audio',
  carnet: 'Questions-réponses',
  texte: 'Conversation',
  image: 'Visuel',
  restitution: 'Vidéo',
  capsule: 'Vidéo',
  tdr: 'Word et Excel',
};
